import React from "react";
import IndexCardSlider from "../components/layout/index/IndexCardSlider";
import styled from "@emotion/styled";
import t from "../helper/t";
import SmartLink from "../components/elements/SmartLink";
import { currentLangIs } from "../helper/utils";
import HeadWithTags from "../components/elements/HeadWithTags";

import imageMessung1 from "../../public/img/know_how/messung_1.png";
import imageMessung2 from "../../public/img/know_how/messung_2.png";
import imageIndexMeasurementExample from "../../public/img/index/de/index-measurement-example.svg";
import imageIndexMeasurementExampleEn from "../../public/img/index/en/index-measurement-example.svg";
import imageClose from "../../public/img/close.svg";
import youtubeImage from "../../assets/images/splus2/speedtest-plus-vodafone-youtube.webp";

const KnowHowFullContainer = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",

  width: "100%",

  [theme.breakpoints.desktop]: {
    minHeight: "600px",
    overflow: "hidden",
  },
}));

const KnowHowContainer = styled.div(({ theme }) => ({
  display: "block",
  width: "100%",
  textAlign: "center",

  marginTop: 18,

  [theme.breakpoints.tablet]: {
    margin: 0,
  },

  [theme.breakpoints.desktop]: {
    maxWidth: "1170px",
  },
}));

const KnowHowTopContainer = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "row-reverse",
  padding: 15,
  columnGap: 11,

  [theme.breakpoints.tablet]: {
    flexDirection: "column",
    alignItems: "end",
  },
}));

const KnowHowClose = styled.div(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  width: "100%",

  boxSizing: "border-box",
  padding: 4,

  cursor: "pointer",
  zIndex: 996,

  img: {
    width: 36,
    height: 36,
  },
}));

const KnowHowBeforeStart = styled.div({
  paddingTop: 0,
});

const KnowHowUmTitle = styled.div(({ theme }) => [
  theme.colors.foreground.secondary,
  theme.typography.knowHowTitle,
  {
    boxSizing: "border-box",
    paddingBottom: 50,

    width: "100%",
    textAlign: "left",

    p: {
      margin: 0,
      padding: 0,
    },

    [theme.breakpoints.tablet]: {
      padding: "0 30px 50px 30px",
      textAlign: "center",
    },
  },
]);

const KnowHowUmTitleContent = styled.div(({ theme }) => [
  theme.colors.foreground.secondary,
  theme.typography.knowHowTitleContent,
  {
    lineHeight: 1,

    textAlign: "left",

    marginTop: 40,
    boxSizing: "border-box",
    padding: "0 20px",
    width: "100%",

    [theme.breakpoints.tablet]: {
      fontWeight: 400,
      textAlign: "center",
    },
  },
]);

const KnowHowUmContent = styled.div(({ theme }) => [
  theme.colors.foreground.secondary,
  theme.typography.regular16,
  {
    lineHeight: 1.38,
    textAlign: "justify",

    boxSizing: "border-box",
    margin: "20px 0",

    width: "100%",
    maxWidth: 750,

    display: "inline-block",

    [theme.breakpoints.tablet]: {
      textAlign: "center",
      padding: "0 20px",
    },
  },
]);

const KnowHowUmHomeImg = styled.div(({ theme }) => ({
  width: 0,
  display: "none",

  [theme.breakpoints.tablet]: {
    margin: "0 auto",
    width: 720,
    maxWidth: 1100,
    height: "auto",
    display: "inline-block",
    position: "relative",
  },
}));

const IndexMeasuringExample = styled.img(({ theme }) => ({
  display: "none",

  marginTop: "70px",
  padding: "0 20px 0 20px",
  boxSizing: "border-box",

  width: "100%",
  maxWidth: 930,

  height: "auto",
  position: "relative",

  [theme.breakpoints.tablet]: {
    display: "inline",
  },
}));

const KnowHowBlocks = styled.div(({ theme }) => ({
  display: "grid",
  width: "100%",

  gridTemplateRows: "repeat(3, auto)",
  gridTemplateColumns: "repeat(1, 1fr)",

  [theme.breakpoints.tablet]: {
    gridTemplateRows: "repeat(1, 1fr)",
    gridTemplateColumns: "repeat(3, 1fr)",

    boxSizing: "border-box",
    padding: "0 30px",
  },
}));

const KnowHowBlock = styled.div(({ theme }) => [
  theme.colors.foreground.secondary,
  theme.colors.background.knowHowBlock,
  {
    width: "100%",
    height: "auto",

    textAlign: "left",
    paddingTop: 20,
    margin: 0,

    display: "flex",
    flexDirection: "column",
    alignItems: "center",

    label: [
      theme.typography.regular20,
      {
        display: "inline-block",
        padding: "10px 0 10px 20px",
        boxSizing: "border-box",
        width: "100%",
      },
    ],

    span: [
      theme.typography.regular16,
      {
        display: "inline-block",
        padding: "10px 0 10px 20px",
        boxSizing: "border-box",
        width: "100%",
      },
    ],

    [theme.breakpoints.tablet]: {
      height: 240,
      textAlign: "center",

      boxSizing: "border-box",
      padding: "10px",
      margin: "10px 0",

      backgroundColor: "unset",

      label: [
        theme.typography.regular16,
        {
          padding: "10px 0 40px 0",
        },
      ],
    },
  },
]);

const KnowHowNetworkAnalyseBlock = styled(KnowHowBlock)(({ theme }) => [
  {
    display: "none",
    [theme.breakpoints.tablet]: {
      display: "inline-block",
    },
  },
]);

const KnowHowInfoImgContainer = styled.div(({ theme }) => ({
  padding: "10px",
  boxSizing: "border-box",

  width: "320px",
  display: "grid",
  gridTemplateRows: "repeat(2, auto)",
  gridTemplateColumns: "repeat(3, 1fr)",

  borderRadius: "6px",
  boxShadow: "0 4px 10px 0 rgba(0, 44, 119, 0.18)",
  zIndex: 100, // we want the box shadow to display over the element underneath

  img: {
    width: "100%",
    height: "auto",
    gridColumn: "1 / span 3",
  },

  span: [
    theme.typography.regular12,
    {
      boxSizing: "border-box",
      padding: "0 2px",
    },
  ],

  "span:nth-child(2)": {
    textAlign: "left",
  },
  "span:nth-child(3)": {
    textAlign: "center",
  },
  "span:nth-child(4)": {
    textAlign: "right",
  },

  [theme.breakpoints.tablet]: {
    display: "none",
  },
}));

const VideoMargin = 20;
const VideoScreenRatio = 9.0 / 16.0;
const MaxVideWidth = 640;

const VideoResponsiveDiv = styled.div([
  {
    marginTop: 48,
    marginLeft: VideoMargin,
    marginRight: VideoMargin,
    textAlign: "center",
  }
]);

const VideoResponsiveImg = styled.img([
  {
    maxWidth: MaxVideWidth,
    width: `calc(100vw - ${2 * VideoMargin}px)`,
    maxHeight: MaxVideWidth * VideoScreenRatio,
    height: `calc(${100 * VideoScreenRatio}vw - ${2 * VideoMargin * VideoScreenRatio}px)`,
  }
]);

const KnowHowComponent: React.FC<{}> = () => {
  return (
    <>
      <HeadWithTags name="know_how" />
      <KnowHowFullContainer>
        <KnowHowContainer>
          <KnowHowTopContainer>
            <SmartLink href="/">
              <KnowHowClose>
                <img src={imageClose.src} alt="X" />
              </KnowHowClose>
            </SmartLink>
            <KnowHowUmTitle>
              <p>{t("Was macht der Speedtest Plus?")}</p>
            </KnowHowUmTitle>
          </KnowHowTopContainer>

          <br />

          <KnowHowBeforeStart>
            <KnowHowUmTitleContent>
              <KnowHowUmContent>
                {t(
                  "Du möchtest wissen, wie schnell Dein Internet wirklich ist? Der Speedtest Plus misst die Geschwindigkeiten von Upload, Download und der Reaktionszeit -Ping- in Deinem Heimnetzwerk."
                )}
                <br />
                <br />
                {t(
                  "Die tatsächliche Geschwindigkeit hängt von vielen verschiedenen Faktoren ab. Wenn wir beim Test merken, dass Dein Internet langsamer ist als der Tarif verspricht, prüfen wir bei Vodafone-Kunden mit Kabel-Anschluss noch die Strecke von unseren Servern bis zu Deinem Router. Und untersuchen Dein Heimnetzwerk. Keine Sorge, persönliche Daten werden dabei nicht erhoben."
                )}
              </KnowHowUmContent>
            </KnowHowUmTitleContent>

            <VideoResponsiveDiv>
              <a href="https://youtu.be/lEcI_DrUqBU" target="_blank">
                <VideoResponsiveImg src={youtubeImage.src} />
              </a>
            </VideoResponsiveDiv>

            <KnowHowUmHomeImg>
              <IndexMeasuringExample
                src={
                  currentLangIs("en")
                    ? imageIndexMeasurementExampleEn.src
                    : imageIndexMeasurementExample.src
                }
                alt="Messung Diagramm"
                loading="lazy"
              />
            </KnowHowUmHomeImg>
          </KnowHowBeforeStart>

          <KnowHowUmTitleContent>
            {t("Die tatsächliche Geschwindigkeit hängt von vielen Faktoren ab")}{" "}
          </KnowHowUmTitleContent>

          <KnowHowBlocks>
            <KnowHowBlock>
              <label>{t("Messung 1")}</label>
              <span>
                {t(
                  "Im ersten Schritt prüfen wir die Download- und Upload-Geschwindigkeit sowie die Reaktionszeit Deines Computers."
                )}
              </span>

              <KnowHowInfoImgContainer>
                <img src={imageMessung1.src} alt="messung1" />
                <span>{t("Unser Server")}</span>
                <span>{t("Router")}</span>
                <span>{t("Dein Smartphone")}</span>
              </KnowHowInfoImgContainer>
            </KnowHowBlock>

            <KnowHowBlock>
              <label>{t("Messung 2")}</label>
              <span>
                {t(
                  "Wenn wir bei der ersten Messung merken, dass Dein Internet langsamer ist als gedacht, prüfen wir bei Vodafone-Kunden mit Kabel-Anschluss noch die Strecke von unseren Servern bis zu Deinem Router."
                )}
              </span>

              <KnowHowInfoImgContainer>
                <img src={imageMessung2.src} alt="messung2" />
                <span>{t("Unser Server")}</span>
                <span>{t("Router")}</span>
              </KnowHowInfoImgContainer>
            </KnowHowBlock>

            <KnowHowNetworkAnalyseBlock>
              <label>{t("Heimnetzwerk-Analyse")}</label>
              <span>
                {t(
                  "Wenn nötig, analysieren wir noch Deinen Software- und Gerätestatus, um Dir individuelle Optimierungs-Tipps zu geben."
                )}
              </span>
            </KnowHowNetworkAnalyseBlock>
          </KnowHowBlocks>

          <p className="um-title-content-small">
            {t("Beste Voraussetzungen für exakte Ergebnisse")}
          </p>

          <IndexCardSlider />
        </KnowHowContainer>
      </KnowHowFullContainer>
    </>
  );
};

export default KnowHowComponent;
